<template>
    <div class="pageBox">
        <PageComponent publicTemplateName="未注册" :publicStatus="1300"></PageComponent>
    </div>
</template>

<script>
import PageComponent from "./PageComponent"
export default {
    components: {PageComponent},
    data() {
        return{
            
        }
    },
    methods: {
        
    },
    watch: {
        
    },
    mounted() {
        
    },
}
</script>

<style lang="stylus" scoped>
    
</style>